import { render, staticRenderFns } from "./VizParagraph.vue?vue&type=template&id=f8a8219c&scoped=true&"
import script from "./VizParagraph.vue?vue&type=script&lang=js&"
export * from "./VizParagraph.vue?vue&type=script&lang=js&"
import style0 from "./VizParagraph.vue?vue&type=style&index=0&id=f8a8219c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a8219c",
  null
  
)

component.options.__file = "VizParagraph.vue"
export default component.exports